export default "__VITE_ASSET__BDvc2VdG__"